import { useState } from 'react';
import data from '../data/ranking.json';

function Rankings() {
  // get max 200 rows
  const maxRows = 200;
  const rows = data.slice(0, maxRows);

  // get unique continent names
  const continents = Array.from(new Set(rows.map(item => item.Continent)));

  const [selectedContinent, setSelectedContinent] = useState('All');
  const filteredRows = selectedContinent === 'All' 
    ? rows 
    : rows.filter(item => item.Continent === selectedContinent);
  
  const stats = {}
  rows.forEach(item => {
    if (stats[item.country]) {
      stats[item.country].count += 1;
    } else {
      stats[item.country] = { count: 1, dollars: item["GDP per capita (USD)"] };
    }
  });
  const sortedStats = Object.entries(stats).sort((a, b) => b[1].count - a[1].count);
  console.log('sortedStats', sortedStats);

  return (
    <div className="min-h-screen bg-gradient-to-br from-bluexx-600 via-purplexx-500 to-pinkxx-400 from-red-800 via-red-500 to-red-200 py-8 px-4">
      <div className="max-w-3xl mx-auto bg-white/90 p-0 md:p-8">
        <div className="mb-10 text-center">
          <h2 className="text-4xl font-extrabold text-white mb-4">University Rankings (prelim)</h2>
          <p className="text-gray-200 text-lg">
            Methodology: The rankings are based on the overall score calculated from various factors, ...
          </p>
        </div>

        <div className="mb-6">
          <label htmlFor="continent-select" className="block text-gray-700 text-lg font-semibold mb-2">
            Filter by Continent:
          </label>
          <select
            id="continent-select"
            value={selectedContinent}
            onChange={(e) => setSelectedContinent(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg bg-white bg-opacity-90 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="All">Global</option>
            {continents.map((continent, index) => (
              <option key={index} value={continent}>
                {continent}
              </option>
            ))}
          </select>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-white bg-opacity-80 text-gray-700 text-lg">
                <th className="px-2 md:px-6 py-3 font-bold">Rank</th>
                { selectedContinent !== 'All' && (
                <th className="px-2 md:px-6 py-3 font-bold">Global Rank</th>
                )}
                <th className="px-2 md:px-6 py-3 font-bold">University</th>
                <th className="px-2 md:px-6 py-3 font-bold">Score</th>
              </tr>
            </thead>
            <tbody>
              {filteredRows.map((item, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-white bg-opacity-70" : "bg-white bg-opacity-50"}
                >
                  { selectedContinent !== 'All' && (
                  <td className="px-2 md:px-6 py-3 text-center font-semibold text-gray-800">{index + 1}</td>
                  )}
                  <td className="px-2 md:px-6 py-3 text-center font-semibold text-gray-800">{item.overall_ranking}</td>
                  <td className="px-2 md:px-6 py-3 text-gray-700">{item.university}</td>
                  <td className="px-2 md:px-6 py-3 text-center text-black font-bold">{parseFloat(item.overall_score).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-20 text-center">
          <h2 className="text-4xl font-extrabold text-white mb-4">Statistics by Country</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-white bg-opacity-80 text-gray-700 text-lg">
                <th className="px-2 md:px-6 py-3 font-bold">Country</th>
                <th className="px-2 md:px-6 py-3 font-bold">Number of Universities</th>
                <th className="px-2 md:px-6 py-3 font-bold">GDP per Capita (USD)</th>
              </tr>
            </thead>
            <tbody>
              {sortedStats.map((item, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-white bg-opacity-70" : "bg-white bg-opacity-50"}
                >
                  <td className="px-2 md:px-6 py-3 text-center font-semibold text-gray-800">{item[0]}</td>
                  <td className="px-2 md:px-6 py-3 text-gray-700">{item[1].count}</td>
                  <td className="px-2 md:px-6 py-3 text-center text-black font-bold">{item[1].dollars}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}

export default Rankings;
